import { Components, Theme } from '@mui/joy';

declare module '@mui/joy/Select' {
  interface SelectPropsVariantOverrides {
    topbar: true;
  }
}

export const JoySelectConfig: Partial<Components<Theme>> = {
  JoySelect: {
    styleOverrides: {
      root: ({ theme, ownerState }) => {
        return {
          ...(!ownerState.error && {
            borderColor: theme.palette.neutral[300],
          }),
          backgroundColor: theme.palette.common.white,
          boxShadow: 'none',
          borderRadius: '4px',
          minHeight: '40px',
          paddingRight: '6px',
          color: theme.palette.neutral.outlinedColor,
          '&:hover': {
            backgroundColor: 'inherit',
            borderColor: ownerState.error ? theme.palette.danger[500] : theme.palette.primary[500],
          },
          '&.is-invalid': {
            borderColor: 'var(--joy-palette-danger-500)',
          },
          ...(ownerState.variant === 'topbar' && {
            '--Icon-color': theme.palette.common.white,
            color: theme.palette.common.white,
            border: '1px solid var(--joy-palette-neutral-500)',
            backgroundColor: 'transparent',
            '&:hover': {
              '--Icon-color': theme.palette.neutral[400],
              backgroundColor: 'transparent',
              color: theme.palette.neutral[400],
            },
            '&:active': {
              '--Icon-color': theme.palette.neutral[500],
              color: theme.palette.neutral[500],
            },
          }),
          '.clear-indicator': {
            minWidth: '28px',
            minHeight: '28px',
          },
        };
      },
      indicator: () => {
        return {
          '.MuiSelect-endDecorator + &': {
            marginInlineStart: '8px',
          },
          minWidth: '28px',
          minHeight: '28px',
        };
      },
    },
  },
};
